import { is } from '@common/is/is'

import type { TBrowser, TBrowserVersion, IBrowserRestrictionData } from '../definitions'

import isRestrictedByVersion from './isRestrictedByVersion'

/**
 * Korlátozva van a Browser alapján?
 * @param browser        - Browser korlátozás adatai.
 * @param browserName    - Browser neve.
 * @param browserVersion - Browser verziószáma.
 */
export default function isBrowserRestricted (
  browser: IBrowserRestrictionData,
  browserName: TBrowser,
  browserVersion: TBrowserVersion
): boolean {
  const { name, version } = browser

  if (name !== browserName) {
    return false
  }
  // Ha megegyezik a Browser neve, de nincs verziószámhoz kötve, akkor tiltás
  else if (is.undefined(version)) {
    return true
  }

  return isRestrictedByVersion(version, browserVersion)
}
